export type SnActionHideExpression<D> = (data?: D) => boolean;
